import MainLayout from "@/layout/MainLayout.vue";
export default [
  {
    path: "/dormitory",
    component: MainLayout,
    name: "dormitory",
    redirect: "/dormitory/dormitoryList",
    meta: {
      title: "宿舍管理",
      icon: "shop",
    },
    // hidden: true,
    children: [
      {
        path: "/dormitory/dormitoryList",
        name: "dormitoryList",
        component: () => import("@/views/Dormitory/PageList"),
        meta: {
          title: "宿舍设置",
        },
      },
      {
        path: "/dormitory/peopleList",
        name: "dormitoryPeopleList",
        component: () => import("@/views/Dormitory/PeopleList"),
        meta: {
          title: "宿舍人员",
        },
      },
    ],
  },
];
